/**
 * Analytics sources and payload for the mentions pings, in both arms of
 * growth_2026_q3_new_citation_pings.
 *
 * All five pings built on RedesignedMentionsPing report the same three events with the same
 * two extras, and the source prefix marks which template the viewer saw. That makes control
 * and variant directly comparable: same surfaces, same events, one differing prefix.
 *
 * Source strings must stay <= 64 characters (the Redshift column width); the longest here is
 * well inside that.
 */
import { NewCitationPingCopy } from './newCitationPingCopy';

export interface MentionPingSources {
  impression: string;
  dismiss: string;
  ctaClick: string;
}

export interface MentionPingExtra {
  is_citation: boolean;
  has_citing_author: boolean;
}

/**
 * @param newDesign whether the viewer is in the variant arm (NewCitationPing) rather than the
 *   legacy template.
 */
export function trackingSources(newDesign?: boolean): MentionPingSources {
  const prefix = newDesign ? 'new_citation_ping' : 'new_mention_ping';

  return {
    impression: `${prefix}_impression`,
    dismiss: `${prefix}_dismiss`,
    ctaClick: `${prefix}_cta_click`,
  };
}

/**
 * Recorded instead of the rendered sentence: the two facts that decide which wording the
 * viewer saw, without storing the copy itself. Both arms report them, so the same slices are
 * available on either side of the comparison.
 */
export function trackingExtra({
  isCitation,
  citingAuthorName,
}: NewCitationPingCopy): MentionPingExtra {
  return {
    is_citation: Boolean(isCitation),
    // Mirrors the condition the new template's body copy uses, so this is true exactly when
    // that sentence would have named an author.
    has_citing_author: Boolean(citingAuthorName?.trim()),
  };
}
